import Vue from 'vue'
import App from './App.vue'

import 'boxicons/css/boxicons.min.css'
import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
